import { render, staticRenderFns } from "./employerDetailsClient.vue?vue&type=template&id=01fd5ccc&scoped=true"
import script from "./employerDetailsClient.vue?vue&type=script&lang=js"
export * from "./employerDetailsClient.vue?vue&type=script&lang=js"
import style0 from "./employerDetailsClient.vue?vue&type=style&index=0&id=01fd5ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd5ccc",
  null
  
)

export default component.exports